<template>
  <div class="c-callme o-modal">
    <div class="o-modal__box" v-on-clickaway="closeModal">
      <div class="o-modal__header">
        <div class="o-modal__close" @click="closeModal">
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5313 7.24935C22.1171 7.83514 22.1171 8.78489 21.5313 9.37067L16.5816 14.3204L21.5313 19.2702C22.1171 19.856 22.1171 20.8057 21.5313 21.3915C20.9456 21.9773 19.9958 21.9773 19.41 21.3915L14.4603 16.4417L9.51053 21.3915C8.92475 21.9773 7.975 21.9773 7.38921 21.3915C6.80343 20.8057 6.80343 19.856 7.38921 19.2702L12.339 14.3204L7.38921 9.37067C6.80343 8.78489 6.80343 7.83514 7.38921 7.24935C7.975 6.66356 8.92475 6.66356 9.51053 7.24935L14.4603 12.1991L19.41 7.24935C19.9958 6.66356 20.9456 6.66356 21.5313 7.24935Z"
              fill="black"
            />
          </svg>
        </div>
        <div class="o-modal__title" v-if="lang == 'da'">
          Lad os ringe dig op
        </div>
        <div class="o-modal__title" v-else>You can also call us</div>
      </div>
      <div class="o-modal__content customscroll">
        <div class="c-callme__infobox">
          <div class="icon">
            <img src="../../../../_img/phone.svg" alt="Letter icon" />
          </div>
          <div class="info">
            <div class="info__text" v-if="lang == 'da'">
              Du kan også ringe til os
            </div>
            <div class="info__text" v-else>Call us</div>
            <div class="info__number">{{ companyphone }}</div>
          </div>
        </div>
        <div
          class="c-callme__inputgroup"
          :class="nameValid ? '' : 'c-callme__inputgroup--error'"
        >
          <input
            type="text"
            name="name"
            v-model="name"
            class="c-callme__input"
            :class="{ valid: name }"
          />
          <label v-if="lang == 'da'">Dit navn *</label>
          <label v-else>Your name *</label>
        </div>
        <div class="c-callme__inputgroup">
          <input
            type="text"
            name="company"
            v-model="company"
            class="c-callme__input"
            :class="{ valid: company }"
          />
          <label v-if="lang == 'da'">Virksomhed</label>
          <label v-else>Company</label>
        </div>
        <div
          class="c-callme__inputgroup"
          :class="phoneValid ? '' : 'c-callme__inputgroup--error'"
        >
          <input
            type="text"
            name="phone"
            v-model="phone"
            class="c-callme__input"
            :class="{ valid: phone }"
          />
          <label v-if="lang == 'da'">Telefon *</label>
          <label v-else>Phone *</label>
        </div>

        <div class="c-callme__inputgroup">
          <textarea
            class="c-callme__input c-callme__input--textarea"
            :class="{ valid: message }"
            v-model="message"
          ></textarea>
          <label v-if="lang == 'da'">Hvordan kan vi hjælpe dig?</label>
          <label v-else>How can we help you?</label>
        </div>

        <div
          class="c-callme__heading"
          :class="timeValid ? '' : 'c-callme__heading--error'"
          v-if="lang == 'da'"
        >
          Hvornår vil det passe dig bedst at vi ringer? *
        </div>
        <div
          class="c-callme__heading"
          :class="timeValid ? '' : 'c-callme__heading--error'"
          v-else
        >
          When would be most convenient for us to call you? *
        </div>
        <div
          class="c-callme__options"
          :class="timeValid ? '' : 'c-callme__options'"
        >
          <div
            class="c-callme__option"
            v-for="option in options"
            :key="option.id"
          >
            <input
              :id="'option-' + option.id"
              type="radio"
              name="timerange"
              :value="option.value"
              v-model="time"
            />
            <label :for="'option-' + option.id">
              {{ option.value }}
            </label>
          </div>
        </div>
      </div>
      <div class="o-modal__footer" @click="submit" v-if="lang == 'da'">
        Ring mig op
      </div>
      <div class="o-modal__footer" @click="submit" v-else>
        Call me
      </div>
      <transition name="fade">
        <div class="c-callme__loader" v-if="isLoading">
          <div
            class="c-callme__loader-message"
            v-if="!isSuccess && !error && lang == 'da'"
          >
            Vent venligst mens vi sender din henvendelse
          </div>
          <div
            class="c-callme__loader-message"
            v-if="!isSuccess && !error && lang != 'da'"
          >
            Please wait while we send your inquiry
          </div>
          <div
            class="c-callme__loader-message"
            v-if="isSuccess && lang == 'da'"
          >
            Vi har modtaget din henvendelse og vender tilbage hurtigst muligt.
          </div>
          <div
            class="c-callme__loader-message"
            v-if="isSuccess && lang != 'da'"
          >
            We have received your inquiry and will get back to you as soon as
            possible.
          </div>
          <div
            class="circle-loader"
            :class="{ 'load-complete': isSuccess }"
            v-if="!error"
          >
            <div class="checkmark-form draw"></div>
          </div>
          <div class="c-callme__loader-message" v-if="error && lang == 'da'">
            Der gik noget galt under afsending. Prøv venligst igen.
          </div>
          <div class="c-callme__loader-message" v-if="error && lang != 'da'">
            Something went wrong while sending. Please try again.
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import axios from "axios";

export default {
  name: "CallMe",
  mixins: [clickaway],
  props: {
    companyphone: {
      Type: Number,
    },
    lang: {
      Type: String,
    },
  },
  data: () => {
    return {
      isLoading: false,
      isSuccess: false,
      error: false,
      name: "",
      company: "",
      phone: "",
      message: "",
      time: "",
      options: [
        { id: 1, value: "08.00 - 10.00" },
        { id: 2, value: "10.00 - 12.00" },
        { id: 3, value: "12.00 - 14.00" },
        { id: 4, value: "14.00 - 15.00" },
      ],

      nameValid: true,
      phoneValid: true,
      timeValid: true,
      validationError: false,
    };
  },
  methods: {
    closeModal: function() {
      this.$emit("close");
    },
    submit: function() {
      this.validationError = false;

      if (!this.name) {
        this.nameValid = false;
        this.validationError = true;
      }
      if (!this.phone) {
        this.phoneValid = false;
        this.validationError = true;
      }
      if (!this.time) {
        this.timeValid = false;
        this.validationError = true;
      }
      if (this.validationError) {
        return;
      }
      this.isLoading = true;

      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("company", this.company);
      formData.append("phone", this.phone);
      formData.append("message", this.message);
      formData.append("time", this.time);
      axios
        .post(
          "https://www.esbjerggolfklub.dk/wp-json/sl/v1/contact-form",
          formData
        )
        .then((response) => {
          if (response.data) {
            this.isSuccess = true;
            setTimeout(() => this.closeModal(), 2500);
          } else {
            this.error = true;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss">
@import "../../../../_scss/_vars.scss";
@import "../../../../_scss/utils/utils.scss";

.c-callme {
  &__data {
    display: flex;
  }

  &__image {
    margin-right: 14px;
    min-width: 95px;
    line-height: 0;
    img {
      width: 95px;
      border-radius: 4px;
    }
  }

  &__infobox {
    display: flex;
    margin-bottom: 20px;

    border: solid 1px #24a065;
    border-radius: 10px;
    background-color: rgba($color: #24a065, $alpha: 0.2);

    .icon {
      background-color: #24a065;
      padding: 0 8px;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      img {
        width: 100%;
        height: 100%;
        max-width: 14px;
      }
    }
    .info {
      padding: 14px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 15px;
      margin-left: 8px;

      &__text {
        margin-right: 12px;
        font-size: 16px;
      }
      &__number {
        font-weight: 600;
      }
    }
  }

  &__info {
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 20px;
    color: $c-yellow;

    .name {
      margin-bottom: 7px;
      color: black;
      // font-family: $font-heading;
      font-weight: 900;
      font-size: 16px;
      letter-spacing: -0.25px;
      line-height: 19px;
    }

    .department {
      margin-bottom: 19px;
    }
  }

  &__status {
    margin-top: 28px;
  }

  &__heading {
    margin-top: 21px;
    margin-bottom: 12px;
    color: #232323;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 18px;
    &--error {
      color: red;
    }
  }

  &__options {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }

  &__option {
    width: calc(50% - 1px);
    margin-bottom: 2px;

    input {
      opacity: 0;
      position: fixed;
      width: 0;

      &:checked + label {
        background: $c-green;
        color: white;
      }
    }

    label {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 47px;
      width: 100%;
      border-radius: 4px;
      background-color: #f0f0f0;
      font-size: 15px;
      letter-spacing: -0.12px;
      line-height: 18px;
      font-weight: 500;
      color: black;
      transition: all $t-hover;

      &:hover {
        background: rgba(#e3e3e3, 0.8);
        cursor: pointer;
      }
    }
  }

  &__inputgroup {
    position: relative;
    margin-bottom: 25px;

    label {
      font-size: 14px;
      font-weight: normal;
      position: absolute;
      pointer-events: none;
      top: 6px;
      transition: all $t-nice 0.3s;
      color: #232323;
      opacity: 0.4;
      text-transform: uppercase;
      //   font-family: $universeBold;
    }

    &--error {
      label {
        opacity: 1;
        color: red;
      }
    }
  }

  &__input {
    display: block;
    margin-bottom: 17px;
    width: 100%;
    font-size: 17px;
    letter-spacing: -0.12px;
    line-height: 18px;
    color: #232323;
    border: none;
    border-bottom: 1px solid rgba(163, 145, 121, 0.5);
    padding: 6px 0 12px;

    &:active,
    &:focus-visible {
      outline: none;
    }

    &:focus ~ label,
    &.valid ~ label {
      top: -14px;
      font-size: 11px;
      opacity: 0.7;
    }

    &--textarea {
      height: 131px;
      resize: none;
      // font-family: $universeRegular;
    }
  }

  .error-message {
    color: red;
  }

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: white;

    &-message {
      font-size: 24px;
      line-height: 1.37;
      font-weight: 300;
      max-width: 450px;
      text-align: center;
      margin-bottom: 45px;
      // font-family: $universeRegular;
    }

    .circle-loader {
      margin-bottom: $loader-size/2;
      border: $check-border-thickness solid rgba(0, 0, 0, 0.2);
      border-left-color: $check-color;
      animation: loader-spin 1.2s infinite linear;
      position: relative;
      display: inline-block;
      vertical-align: top;
      border-radius: 50%;
      width: $loader-size;
      height: $loader-size;
    }

    .load-complete {
      -webkit-animation: none;
      animation: none;
      border-color: $check-color;
      transition: border 500ms ease-out;

      .checkmark-form {
        display: block;
      }
    }

    .checkmark-form {
      display: none;

      &.draw:after {
        animation-duration: 800ms;
        animation-timing-function: ease;
        animation-name: checkmark;
        transform: scaleX(-1) rotate(135deg);
      }

      &:after {
        opacity: 1;
        height: $check-height;
        width: $check-width;
        transform-origin: left top;
        border-right: $check-thickness solid $check-color;
        border-top: $check-thickness solid $check-color;
        content: "";
        left: $check-left;
        top: $check-height;
        position: absolute;
      }
    }
  }
}

@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
}

@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/CtaContainer/CallMe/CallMe.vue